import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as dropdownActions from "../../../../actions/dropdowns.actions";
import * as companyActions from "../../../../actions/company.actions";
import * as userActions from "../../../../actions/user.actions";

import Toast from "../../../../components/common/toast/Toast";
import CompanyPaymentInformation from "../components/CompanyPaymentInformation";

class CompanyPaymentInformationContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.dropdownActions.getCompanyPaymentMethods();
    this.props.dropdownActions.getCompanyPaymentTerms();
  }

  handleSubmit(data) {
    const id = _.get(data, "id");

    if (id) {
      this.props.companyActions.updateCompanyPayment(data.company_id, data);
    } else {
      this.props.companyActions.createCompanyPayment(data);
    }

    this.toast.showToast();
  }

  render() {
    return (
      <React.Fragment>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Success!"
          content="Your Billing Information has been saved."
        />
        <CompanyPaymentInformation
          onSubmit={this.handleSubmit}
          paymentMethods={this.props.paymentMethods}
          paymentTerms={this.props.paymentTerms}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    paymentMethods: state.dropdowns.companyPaymentMethods.data,
    paymentTerms: state.dropdowns.companyPaymentTerms.data,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  companyActions: bindActionCreators(companyActions, dispatch),
  dropdownActions: bindActionCreators(dropdownActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyPaymentInformationContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/payment/containers/CompanyPaymentInformationContainer.js